import classNames from "classnames";
import React from "react";

interface IllustrationCardProps {
  imgUrl: string;
  className?: string;
}
const IllustrationCard: React.FC<IllustrationCardProps> = ({
  imgUrl,
  className,
}) => {
  return (
    <img src={imgUrl} className={classNames(className, "absolute  w-32")} />
  );
};

export default IllustrationCard;
